export default "__VITE_ASSET__DUttOXKR__"